import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from "react";
import DataTable from 'react-data-table-component';

import { useMenu } from "../../contexts/MenuContext";
import "./Dashboard.scss";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";



const RADIAN = Math.PI / 180;

const renderLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy + radius * Math.sin(-midAngle * RADIAN);

	return (
		<text
			x={x}
			y={y}
			fill="#fff"
			textAnchor={x > cx ? "start" : "end"}
			dominantBaseline="central"
		>
			{`${Math.round(percent * 100)}%`}
		</text>
	);
};
// Generate a random color
const getRandomColor = () =>
  "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0");
// Rechart
// helper to parse "YYYY-MM-DD HH:mm:ss"
const parseDate = (dateStr) => {
	return new Date(dateStr.replace(" ", "T")); // "2025-08-21T07:56:05"
};
export default function TrafficLog() {	
	const {
		settingData
	} = useMenu();  
	const [loading, setLoading] = useState(false);
	const [reload, setReload] = useState(0);
	// Rechart
	const [pieData, setPieData] = useState([]);
	const [pieLinkData, setPieLinkData] = useState([]);
	const [pieDataColors, setPieDataColors] = useState([]);

	// Get countries data
    useEffect(() => {        
		if (ultimate_security_ajax_obj.isPro) {
        	const getCountriesData = async () => {
				try {
					
					const response = await apiFetch({
						path: '/ultimate-security/v1/get-traffic-log-country-data',
						method: 'GET'
					});    
					setPieData(response);
					
					// assign random colors once per item
					setPieDataColors(response.map(() => getRandomColor()));           
				} catch (error) {
					console.error(error);
				}
			};    
			getCountriesData();
		}
    }, [settingData.security.traffic_log.log_data, reload]);

	// Get url data
    useEffect(() => {        
		if (ultimate_security_ajax_obj.isPro) {
        	const getLinkData = async () => {
				try {
					const response = await apiFetch({
						path: '/ultimate-security/v1/get-traffic-log-url-data',
						method: 'GET'
					});    
					setPieLinkData(response); 
						
				} catch (error) {
					console.error(error);
				}
			};    
			getLinkData();
		}
    }, [settingData.security.traffic_log.log_data, reload]);
	

	
	// Rechart

	useEffect(() => {
		const interval = setInterval(() => {
			setReload(Math.random); // updates with a new random number
		}, 5 * 60 * 1000); // 5 minutes in ms

		return () => clearInterval(interval); // cleanup on unmount
	}, []);

	const refreshAll = () => {
		// Set loading to true to start the rotation
		setReload(Math.random);
		setLoading(true);

	}

	// For data table

	
	
	const [trafficLogTableData, setTrafficLogTableData] = useState([])
    const [trafficLogFilteredTableData, setTrafficLogFilteredTableData] = useState([])
    const [trafficLogSearchQuery, setTrafficLogSearchQuery] = useState('')
    const trafficLogFilterList = [
        { name: __('All', 'ultimate-security'), value: 'all' },
        { name: __('Today', 'ultimate-security'), value: 'today' },
        { name: __('Last 7 days', 'ultimate-security'), value: 'week' },
        { name: __('This Month', 'ultimate-security'), value: 'month' },
    ];    

    const [trafficLogActiveFilter, setTrafficLogActiveFilter] = useState('all')
    const trafficLogColumns = [
        {
			name: "Country",
			selector: row => row.country, // needed for sorting
			sortable: true,
			cell: row => (
				<div className="d-flex align-items-center gap-2">
					<img
						src={`https://flagcdn.com/w20/${row.countryCode.toLowerCase()}.png`}
						alt={row.country}
						className="w-5 h-4 rounded-sm shadow"
					/>
					<span>{row.country}</span>
				</div>
			),
		},
        {
            name: 'URL',
            selector: row => row.url,
            sortable: true,
        },
		{
			name: "IP",
			selector: row => row.ip,
			sortable: true,
		},
		{
			name: "Host",
			selector: row => row.host,
			sortable: true,
		},
		{
			name: "Browser",
			selector: row => row.browser,
			sortable: true,
		},
		{
			name: "Platform",
			selector: row => row.platform,
			sortable: true,
		},
		{
			name: "Device",
			selector: row => row.device,
			sortable: true,
		},
		{
			name: "Response",
			selector: row => row.response,
			sortable: true,
		},
		{
			name: "Time",
			selector: row => row.time,
			sortable: true,
			// sortFunction: (a, b) => new Date(a.date) - new Date(b.date), // custom date sort
		},
    ];

    // Get table data
    useEffect(() => {
		if (ultimate_security_ajax_obj.isPro) {     
			setTrafficLogSearchQuery('');
			setTrafficLogActiveFilter('all'); // Reset the active role
			const getTableData = async () => {
				try {
					const response = await apiFetch({
						path: '/ultimate-security/v1/get-traffic-log-table-data',
						method: 'GET'
					});    
					setTrafficLogTableData(response);
					setTrafficLogFilteredTableData(response);  
					setLoading(false);           
				} catch (error) {
					console.error(error);
				}
			};    
			getTableData();
		}
    }, [reload]);

    const trafficLogHandleDatatableSearch = (e) => {
        const query = e.target.value;
        setTrafficLogSearchQuery(query);
        setTrafficLogActiveFilter('all'); // Reset the active role
        const newData = trafficLogTableData.filter(row => {
            // return row.param.toLowerCase().includes(query.toLowerCase());
            return (
                row.country.toLowerCase().includes(query.toLowerCase()) 
				|| row.url.toLowerCase().includes(query.toLowerCase())
				|| row.ip.toLowerCase().includes(query.toLowerCase())
				|| row.host.toLowerCase().includes(query.toLowerCase())
				|| row.browser.toLowerCase().includes(query.toLowerCase())
				|| row.platform.toLowerCase().includes(query.toLowerCase())
				|| row.device.toLowerCase().includes(query.toLowerCase())
				|| row.response.toLowerCase().includes(query.toLowerCase())
				|| row.time.toLowerCase().includes(query.toLowerCase())
            );
        });
        setTrafficLogFilteredTableData(newData);
    }


	const trafficLogHandleDatatableFilter = (range) => {
		setTrafficLogActiveFilter(range);

		if (range === "all") {
			setTrafficLogFilteredTableData(trafficLogTableData);
			return;
		}

		const now = new Date();
		const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const weekStart = new Date(todayStart);
		weekStart.setDate(weekStart.getDate() - weekStart.getDay()); // start of week (Sunday)
		const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

		const newData = trafficLogTableData.filter((row) => {
			const rowDate = parseDate(row.time);

			if (range === "today") {
				return rowDate >= todayStart;
			}
			// if (range === "week") {
			// 	return rowDate >= weekStart;
			// }
			if (range === "week") {
				const sevenDaysAgo = new Date(now);
				sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
				return rowDate >= sevenDaysAgo;
			}
			if (range === "month") {
				return rowDate >= monthStart;
			}
			return true;
		});

		setTrafficLogFilteredTableData(newData);
	};
	return (
		<>
			{
				settingData?.restrictions?.maxmind?.license_key !=='' ?
				<>
					<div className="mb-3 text-end">				
						<img className={loading ?'rotate':''} src={ultimate_security_ajax_obj.imageUrl+'ipReload.svg'} alt="" onClick={refreshAll} />
					</div>
					<div className="chart-area-wrapper">
						<div className="chart-title">{__('Statistics', 'ultimate-security')}</div>
						<div className="row align-items-center">
							<div 
								className="col-lg-6 border-end"
								style={{paddingTop: 24, paddingBottom:24}}
							>
								<div 
									className="chart-area"
									// style={{ width: "100%", height: 320 }}
								>
									<ResponsiveContainer width="100%" height="100%">
										<PieChart width={480} height={480}>
											<Pie
												data={pieData}
												cx="50%"
												cy="50%"
												outerRadius={240}
												dataKey="value"
												labelLine={false}
												label={renderLabel}
											>
												{pieData.map((entry, index) => (
												<Cell key={`cell-${index}`} fill={pieDataColors[index % pieDataColors.length]} />
												))}
											</Pie>
											<Tooltip/>
										</PieChart>
									</ResponsiveContainer>
								</div>
							</div>
							<div 
								className="col-lg-6"
								style={{paddingTop: 24, paddingBottom:24}}
							>
								<h4 class="fw-600 text-text m-0 mb-3 p-0 ps-3">{__('Title', 'ultimate-security')}</h4>
								<ul className="chart-list px-3">
									{pieLinkData.slice(0, 5).map((item, index) => (
										<li 
											key={item.name} 
											// style={{ "--marker-color": pieDataColors[index] }}
											className="d-flex align-items-center justify-content-between"
										>
											<span>{item.name}</span>
											<span>{item.value}</span>
										</li>
									))}
								</ul>
							</div>
						</div>
					</div>
					<div className="user-datatable datatable-unit pt-lg mt-lg border-top">
						<div className="row align-items-center mb-30">
							<div className="col-7 datatable-filters">
								<div className="d-flex flex-wrap">
									{
										trafficLogFilterList && trafficLogFilterList.map(item => (                                        

											<span 
												key={item.value} 
												onClick={() => trafficLogHandleDatatableFilter(item.value)}
												className={trafficLogActiveFilter === item.value ? 'active' : ''}
											>
												{item.name} 
											</span> 

										))      
									}
								</div>
							</div>
							<div className="col-5">
								<div className="search-unit d-flex justify-content-end">
									<input 
										placeholder="Search" 
										type="search" 
										onChange={trafficLogHandleDatatableSearch} 
										value={trafficLogSearchQuery} 
									/>
								</div>
							</div>
						</div>            
						<div className="table-wrapper border">
							<DataTable
								columns={trafficLogColumns}
								data={trafficLogFilteredTableData} // Use filtered data
								pagination
								paginationPerPage={5} // Default to 5 rows per page
								paginationRowsPerPageOptions={[5, 10]} // Options with 5 first
								dense
								responsive
								defaultSortFieldId={9} // column index (9th column = Date)
      							defaultSortAsc={false} // false = descending
							/>
						</div> 
					</div>
				</> : 
				<>
					<span>Message for active MaxMind</span>
				</>
			}
			
		</>
	);
}
